
export const formatCriteriaArray = (criterias) => {
  return criterias.map((criteria) => {
    let criteriaField = criteria.field
    let obj = {}
    obj.field = criteriaField.field
    obj.fieldType = criteriaField.fieldType
    obj.fromSectionFieldId = criteria.sectionAndFieldIds[1]
    return obj
  })
}

export const formatRetroArray = (retros) => {
  return retros.map((retro) => {
    let retroField = retro.field
    let obj = {}
    obj.toFieldId = retroField.toFieldId
    obj.toFieldIdType = retroField.toFieldIdType
    obj.fromSectionFieldId = retro.sectionAndFieldIds[1]
    obj.mustDeleteToFieldValueWhenFromSectionFieldIsNull = retro.mustDeleteToFieldValueWhenFromSectionFieldIsNull
    obj.fromSectionFieldType = retroField.fromSectionFieldType
    return obj
  })
}

export const makeRetroObject = (form) => {
  let newObj = {...form}
  delete newObj.entityTypeId
  delete newObj.clientId
  delete newObj.activityId
  delete newObj.criteriaFields
  delete newObj.retroalimentationFields
  newObj.operation = {
    operation: newObj.operation,
    criterias: []
  }
  newObj.retroalimentationFields = []
  return [newObj]
}

export const mount = (form) => {
  let criterias = formatCriteriaArray(form.criteriaFields)
  let retros = formatRetroArray(form.retroalimentationFields)
  let retroObject = makeRetroObject(form)
  retroObject[0].operation.criterias = criterias
  retroObject[0].retroalimentationFields = retros
  return retroObject
}

export default {
  formatCriteriaArray,
  formatRetroArray,
  makeRetroObject,
  mount
}